import EventsAdapter from './base';

export default class Event extends EventsAdapter {
  modelNamePlural = 'events';
}
